import React from "react";
import PropTypes from "prop-types";
import { PathwayLabel } from "../../StyledComponents/PathwayForm";

const PathwaySwitchInputGroup = (props) => {
    return (
        <div
            className="form-check form-switch"
            data-cy={props.dataCy ? props.dataCy + "-wrapper" : undefined}
            style={props.justifyEnd ? { justifyItems: "end" } : undefined}
        >
            <input
                type="checkbox"
                className="form-check-input"
                role="switch"
                name={props.name}
                id={props.id || props.name}
                onChange={props.onChange || (() => {})}
                checked={!!props.value}
                data-cy={props.dataCy ? props.dataCy + "-checkbox" : undefined}
                disabled={props.disabled}
                aria-label={props.ariaLabel}
            />
            <PathwayLabel
                data-cy={props.dataCy ? props.dataCy + "-label" : undefined}
                className="form-check-label custom-control-label"
                htmlFor={props.id || props.name}
                style={{ float: "left" }}
            >
                {props.label}
            </PathwayLabel>
        </div>
    );
};

export default PathwaySwitchInputGroup;

PathwaySwitchInputGroup.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string,
    value: PropTypes.bool,
    onChange: PropTypes.func,
    dataCy: PropTypes.string,
    label: PropTypes.any,
    ariaLabel: PropTypes.string,
    justifyEnd: PropTypes.bool,
    disabled: PropTypes.bool,
};
